<template>
  <div>
    <div class="f-flex f-mb-2">
      <input
        type="checkbox"
        class="f-form-checkbox f-w-4 f-h-4 f-rounded f-border-gray-400 focus:f-ring-2 f-mt-1"
        :id="$id('discount-code-checkbox')"
        v-model="showDiscountCodeInput"
        @change="discountCodeCheckboxChanged($event.target.checked)"
      />
      <a
        href="javascript:void(0);"
        @click.prevent="showDiscountCodeInput = !showDiscountCodeInput"
        class="f-ml-3 f-text-blue-500 hover:f-underline cursor-pointer"
      >
        {{ $t("result.discount_code.link.label") }}
      </a>
    </div>

    <template v-if="showDiscountCodeInput">
      <div class="f-mt-1 f-flex f-rounded-md f-shadow-sm">
        <div
          class="f-relative f-flex f-items-stretch f-flex-grow focus-within:f-z-10"
        >
          <input
            type="text"
            v-model="discountCode"
            @blur="$emit('discountCodeChanged', discountCode)"
            class="f-form-input f-block f-py-1 f-w-full f-rounded-l f-border-gray-300 f-text-gray-700"
          />
        </div>
        <button
          :disabled="isProcessing"
          @click.prevent="$emit('tryToApplyDiscountCode')"
          class="f--ml-px f-relative f-inline-flex f-items-center f-px-2 f-py-1 f-border f-border-gray-300 f-text-sm f-rounded-r-md f-text-white f-bg-blue-500 hover:f-bg-blue-600 focus:f-outline-none focus:f-ring-1 focus:f-ring-blue-500 focus:f-border-blue-500"
        >
          <svg
            v-show="isProcessing"
            aria-hidden="true"
            focusable="false"
            data-prefix="far"
            class="f-h-5 f-w-5 f-text-gray-400 f-animate-spin f-mr-1"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path
              fill="currentColor"
              d="M460.116 373.846l-20.823-12.022c-5.541-3.199-7.54-10.159-4.663-15.874 30.137-59.886 28.343-131.652-5.386-189.946-33.641-58.394-94.896-95.833-161.827-99.676C261.028 55.961 256 50.751 256 44.352V20.309c0-6.904 5.808-12.337 12.703-11.982 83.556 4.306 160.163 50.864 202.11 123.677 42.063 72.696 44.079 162.316 6.031 236.832-3.14 6.148-10.75 8.461-16.728 5.01z"
            ></path>
          </svg>
          <span>{{ $t("result.discount_code.apply.label") }}</span>
        </button>
      </div>

      <div class="f-text-red-500 f-text-sm" v-if="state === false">
        {{ $t("result.discount_code.validations.invalid_code") }}
      </div>

      <div class="f-text-green-500 f-text-sm" v-if="state === true">
        {{ $t("result.discount_code.applicable") }}
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import UrlParser from "@/module/Utils/UrlParser";
import { isBooleanOrNull } from "@/module/ComponentPropsValidations/validations";

interface ComponentData {
  discountCode: string;
  showDiscountCodeInput: boolean;
}

export default Vue.extend({
  name: "DiscountCode",
  components: {},
  props: {
    state: {
      required: true,
      validator: isBooleanOrNull,
    },
    isProcessing: {
      type: Boolean,
      required: true,
    },
  },

  data(): ComponentData {
    return {
      discountCode: "",
      showDiscountCodeInput: false,
    };
  },

  methods: {
    discountCodeCheckboxChanged(checked: boolean): void {
      if (checked) {
        this.$emit("discountCodeChanged", this.discountCode);
      } else {
        this.$emit("discountCodeChanged", "");
      }

      this.$nextTick(() => {
        this.$emit("tryToApplyDiscountCode");
      });
    },
  },

  mounted(): void {
    const urlParser = UrlParser.getInstance();
    const discountCode = urlParser.getParam("fapi-form-discountCode");

    if (discountCode === null) {
      return;
    }

    this.discountCode = String(discountCode);

    if (this.discountCode !== "") {
      this.showDiscountCodeInput = true;
      this.$emit("discountCodeChanged", this.discountCode);
      this.$emit("tryToApplyDiscountCode", this.discountCode);
    }
  },
});
</script>

<style lang="scss"></style>
